import { useState } from 'react';

export default function ToggleMore(props) {
  const [visible, setVisible] = useState(false);

  const toggleMore = (list) => {
    //Handle focus on toggle
    if (!visible) {
      // IE11 is not supporting spreaded arrays [...list] and Array.from(), instead of polyfill
      // create a NodeList
      const visElements = list.querySelectorAll('li');
      // create array from NodeList
      const visElementsArray = Array.prototype.slice.call(visElements);
      // filter array
      visElementsArray.filter(
        (el) => window.getComputedStyle(el).display !== 'none'
      );
      const lastItem = visElementsArray && visElementsArray.pop();
      const span = lastItem && lastItem.querySelector('span[tabindex]');
      span.focus();
    }

    setVisible(!visible);
  };

  const { children } = props;

  return children({
    visible: visible,
    toggleMore: toggleMore,
  });
}
